




























































import Vue from "vue";

import VJsf from "@koumoul/vjsf/lib/VJsf.js";
import "@koumoul/vjsf/lib/VJsf.css";
import "@koumoul/vjsf/lib/deps/third-party.js";

import { GetDataFlowDeviceDetailsCommand } from "@/model/communication/dataFlow/GetDataFlowDeviceDetailsCommand";
import { GetDataFlowDeviceDetailsResData } from "@/model/communication/dataFlow/GetDataFlowDeviceDetailsResData";
import { GetDataFlowDeviceDetailsSchemaCommand } from "@/model/communication/dataFlow/GetDataFlowDeviceDetailsSchemaCommand";
import { GetDataFlowDeviceDetailsSchemaResData } from "@/model/communication/dataFlow/GetDataFlowDeviceDetailsSchemaResData";
import { GetDataFlowOrganizationsConvertersCommand } from "@/model/communication/dataFlow/GetDataFlowOrganizationsConvertersCommand";
import { GetDataFlowOrganizationsConvertersResData } from "@/model/communication/dataFlow/GetDataFlowOrganizationsConvertersResData";
import { PostDataFlowDeviceDetailsCommand } from "@/model/communication/dataFlow/PostDataFlowDeviceDetailsCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";

export default Vue.extend({
    components: { VJsf },
    props: {
        installationName: String,
    },
    data() {
        return {
            loading: false,
            deviceDetailData: {},
            deviceDetailSchema: {},
            deviceDetailOptions: {
                initialValidation: "defined",
                autofocus: false,
                locale: "en",
                objectContainerClass: "justify-start",
                sectionsTitlesClasses: ["text-h5", "text-h6", "text-h7"],
            },
            deviceDetailValid: false,
            showError: false,
            showErrorBlocking: false,
            errorMessage: "",
            converters: [],
            selectedConverter: null,
            isDeviceDetailAlreadySent: false,
        };
    },
    watch: {
        installationName: {
            handler(newValue) {
                if (newValue) {
                    this.setupForm(newValue, true);
                }
            },
            immediate: true,
        },
    },
    methods: {
        async setupForm(installationName: string, getConverters: boolean) {
            this.showError = false;
            this.showErrorBlocking = false;
            this.errorMessage = "";
            this.loading = true;
            this.deviceDetailData = {};
            this.deviceDetailSchema = {};
            if (getConverters) {
                this.converters = [];
                await this.getOrganizationsConverter();
                this.selectedConverter = this.converters[0];
            }
            if (this.selectedConverter) {
                await this.getDeviceDetails(installationName, this.selectedConverter);
                await this.getDeviceDetailsSchema(this.selectedConverter);
            }
            this.loading = false;
        },
        async getDeviceDetails(installationName: string, converterType: string) {
            try {
                let response: GetDataFlowDeviceDetailsResData = await new GetDataFlowDeviceDetailsCommand(installationName, converterType).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.deviceDetails) {
                    this.deviceDetailData = response.deviceDetails;
                    if (!response.isDeviceDetailAlreadySent) {
                        this.showError = true;
                        this.errorMessage = this.$t("dataFlow.deviceDetailNotSent");
                    } else if (response.isDeviceDetailIncomplete) {
                        this.showError = true;
                        this.errorMessage = this.$t("dataFlow.deviceDetailIncomplete");
                    }
                } else if (response.message != "404") {
                    this.showErrorBlocking = true;
                    this.errorMessage = response.message;
                }
            } catch (e) {
                console.log("Something went wrong sending GetDataFlowDeviceDetailsCommand request ", e);
            }
        },
        async getDeviceDetailsSchema(converterType: string) {
            try {
                let response: GetDataFlowDeviceDetailsSchemaResData = await new GetDataFlowDeviceDetailsSchemaCommand(converterType).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.deviceDetailsSchema) {
                    this.deviceDetailSchema = response.deviceDetailsSchema;
                } else {
                    this.errorMessage = response.message.split(",").find((s) => s.includes("detail"));
                    if (this.errorMessage) this.errorMessage = this.errorMessage.replace("detail:", "");
                    else this.errorMessage = response.message;
                    this.showErrorBlocking = true;
                }
            } catch (e) {
                console.log("Something went wrong sending GetDataFlowDeviceDetailsSchemaCommand request ", e);
            }
        },
        async postDeviceDetails(): Promise<boolean> {
            if (!this.deviceDetailValid) return;
            try {
                let response: ApiGenericResponse = await new PostDataFlowDeviceDetailsCommand(this.installationName, this.selectedConverter, this.deviceDetailData).execute();
                if (response.responseStatus != ApiResponseStatusEnum.Success || response.responseString != "Success") {
                    this.errorMessage = response.message.split(",").find((s) => s.includes("detail"));
                    if (this.errorMessage) {
                        this.errorMessage = this.errorMessage.replace("detail:", "");
                        if (this.errorMessage.includes("not compliant")) this.errorMessage = this.$t("dataFlow.deviceDetailIncomplete");
                    } else this.errorMessage = response.message;
                    this.showError = true;
                    return false;
                }
            } catch (e) {
                console.log("Something went wrong sending PostDataFlowDeviceDetailsCommand request ", e);
                return false;
            }
            return true;
        },
        async submitForm() {
            this.loading = true;
            let res = await this.postDeviceDetails();
            if (res) await this.setupForm(this.installationName, false);
            this.loading = false;
        },
        async getOrganizationsConverter() {
            try {
                let response: GetDataFlowOrganizationsConvertersResData = await new GetDataFlowOrganizationsConvertersCommand(false).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (response.converterTypes == null || response.converterTypes.length == 0) {
                        this.showErrorBlocking = true;
                        this.errorMessage = this.$t("dataFlow.noConverterError");
                    }
                    this.converters = response.converterTypes;
                } else {
                    this.showError = true;
                    this.errorMessage = response.message;
                }
            } catch (e) {
                console.log("Something went wrong sending PostDataFlowDeviceDetailsCommand request ", e);
            }
        },
    },
    mounted() {
        window.addEventListener("reload-dataflow-card", (event: any) => {
            this.setupForm(event.detail.installationName, true);
        });
    },
});
